<template>
  <span></span>
</template>

<script>
import { mapState } from "vuex";
import calendarCheck from "@/mixins/tags/calendarCheck";
import apiClientCreator from "@/helpers/api/request";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";

export default {
  name: "MainChartsController",
  mixins: [calendarCheck, UsersPermissionCheck],
  props: {
    activeTags: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "generalQueryObject",
      "chartsMainView",
      "chartsViewBlocks",
      "multiSelectChartData",
      "selectedTopTag",
      "selectedTag",
      "shortCutsToBlocks",
      "selectedCalendar",
      "clientsTableSelectedTab",
      "selectedCalendarType"
    ])
  },
  data() {
    return {
      datesFilter: [],
      preBlocks: {}
    };
  },
  mounted() {
    if (this.CheckUserPermission([7])) {
      let blocks = Object.assign({}, this.chartsViewBlocks);
      blocks[3] = "call_again";
      this.$store.commit("clients/setChartsViewBlocks", blocks);
    }
    if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
      let blocks = Object.assign({}, this.chartsViewBlocks);
      blocks[3] = "assignments";
      this.$store.commit("clients/setChartsViewBlocks", blocks);
    }
  },
  watch: {
    clientsTableSelectedTab: function() {
      let blocks = Object.assign({}, this.chartsViewBlocks);
      if (this.clientsTableSelectedTab.tabAlias === "questions") {
        blocks[1] = "questions";
        blocks[2] = "questions";
        blocks[3] = "questions";
        blocks[4] = "questions";
      } else if (this.clientsTableSelectedTab.tabAlias === "campaign") {
        blocks[1] = "advertising";
        blocks[2] = "keyword";
        blocks[3] = "device";
        blocks[4] = "placement";
      } else if (this.clientsTableSelectedTab.tabAlias === "campaign-2") {
        blocks[1] = "click_type";
        blocks[2] = "location";
        blocks[3] = null;
        blocks[4] = null;
      } else {
        blocks[1] = "deposits";
        blocks[2] = null;
        blocks[3] = "assignments";
        blocks[4] = null;
      }
      this.$store.commit("clients/setChartsViewBlocks", blocks);
    },
    selectedTopTag: function() {
      let dataObject = Object.assign({}, this.multiSelectChartData);
      let selectedGraph;
      let blockForCharts = this.getCurrentBlock(this.selectedTopTag);
      let blocks = Object.assign({}, this.chartsViewBlocks);
      if (blockForCharts !== undefined) {
        selectedGraph = blockForCharts.block;
      } else {
        blockForCharts = this.shortCutsToBlocks.find(tab => {
          return tab.short === "DP";
        });
        selectedGraph = blockForCharts.block;
      }

      dataObject.selectedSector = selectedGraph;
      blocks[1] = selectedGraph;
      this.$store.commit("clients/setMultiSelectChartData", [
        dataObject,
        selectedGraph
      ]);
      this.$store.commit("clients/setChartsViewBlocks", blocks);

      if (this.selectedTag === "mc") {
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: "CA_P",
          preset: null
        });
      }
      // if (this.selectedTopTag === "CA_T") {
      //   this.$store.commit("clients/setSelectedCalendarType", {
      //     alias: "CA_F",
      //     preset: "TODAY"
      //   });
      // }
      if (
        this.activeTags.length > 0 &&
        this.selectedCalendarType.alias !== blockForCharts.calendar
      )
        this.$store.commit("clients/setSelectedCalendarType", {
          alias: blockForCharts.calendar,
          preset: null
        });
    },
    multiSelectChartData: {
      handler() {
        this.handleReceivedData();
      },
      deep: true
    },
    activeTags: function() {
      // set the chart by last tag that selected
      let dataObject = Object.assign({}, this.multiSelectChartData);
      let block;
      block = this.getCurrentBlock(
        this.activeTags[this.activeTags.length - 1]
          ? this.activeTags[this.activeTags.length - 1]
          : ""
      );

      if (block) {
        let selectedGraph = block.block;
        let blocks = Object.assign({}, this.chartsViewBlocks);

        dataObject.selectedSector = selectedGraph;

        blocks = this.handleBlock_1(blocks, selectedGraph);

        // blocks = this.handleBlock_3(blocks,selectedGraph);

        this.$store.commit("clients/setMultiSelectChartData", [
          dataObject,
          selectedGraph
        ]);
        this.$store.commit("clients/setChartsViewBlocks", blocks);

        if (
          this.activeTags.length > 0 &&
          this.selectedCalendarType.alias !== block.calendar
        )
          this.$store.commit("clients/setSelectedCalendarType", {
            alias: block.calendar,
            preset: null
          });
      }
    }
    // }
  },
  methods: {
    handleReceivedData() {
      let dataObject = Object.assign({}, this.multiSelectChartData);
      let blocks = Object.assign({}, this.chartsViewBlocks);
      blocks = this.setBlocksView(blocks, dataObject);

      this.$store.commit("clients/setChartsViewBlocks", blocks);
    },

    setBlocksView(blocks, data) {
      // if (data.selectedSector === "questions") {
      //   blocks[1] = data.selectedSector;
      //   blocks[2] = data.selectedSector;
      //   blocks[3] = data.selectedSector;
      //   blocks[4] = data.selectedSector;
      // }

      return blocks;
    },
    getCurrentBlock(tag) {
      return this.shortCutsToBlocks.find(tab => {
        return tab.short === tag || tab.tag === tag;
      });
    },

    handleBlock_1(blocks, selectedGraph) {
      blocks[1] = selectedGraph;

      if(selectedGraph === 'register'){
        if(this.generalQueryObject.hasOwnProperty('deposit_at_from')){
          blocks[1] = 'deposits';
        }
      }
      return blocks;
    },

    handleBlock_3(blocks, selectedGraph) {
      blocks[3] = selectedGraph;
      return blocks;
    }
  }
};
</script>

<style scoped>
span {
  display: none;
}
</style>
